import Api from '../api/api.js';

import Toaster from '../alerts/toaster.js';


export default class DragDropManager {


	constructor(items, url, params) 
	{
		this.setParams(params);
		this.setItems(items);
		this.setUrl(url);
	}

	init()
	{
		this.cacheDom();
		this.initDragDrop();
	}

	cacheDom() 
	{
		this.$selected_form = $('#' + this.params.form_id);
		this.$droptrue      = $("ul.droptrue");
		this.$dropfalse     = $("ul.dropfalse");
		this.$sortable      = $(".sortable-items");
	}

	onSaveItems(e)
	{
 		const data = this.$selected_form.serializeObject();

 		this.saveItems(data)

 			.then((response) => {

 				(new Toaster).toast('Success', response.msg, 'success');

 			})
 			.catch(() => {
 		
				this.reloadWindow();

 			});
 	}


 	saveItems(data)
 	{
 		return new Promise((resolve, reject) => {

 			(new Api).putRequest(this.url, data).then((response) => {

 				resolve(response);

 			});

 		});
 	}


 	reloadWindow()
 	{
 		setTimeout(function() {
			
			window.location.reload();
		
		}, 1000);
 	}


	initDragDrop() 
	{
		this.$droptrue.sortable({connectWith: "ul"});
		this.$dropfalse.sortable({
	      	connectWith: "ul",
	      	receive: this.onSaveItems.bind(this, event),
		    remove:  this.onSaveItems.bind(this, event)
	    });
	    this.$sortable.disableSelection();
	}


	setParams(params)
	{
		if (typeof params !== 'object'){
			throw new Error('Params must be an object');
		}
		const defaults = {
			form_id:'selected-form'
		}
		this.params = $.extend({}, defaults, params);
		return this;
	}

	setItems(items)
	{
		if (typeof items !== 'object'){
			throw new Error('Items must be an array');
		}
		if (!Array.isArray(items)){
			throw new Error('Items must be an array');
		}
		this.items = items; 
		return this;
	}

	setUrl(url)
	{
		if (typeof url !== 'string'){
			throw new Error('Url must be a string');
		}
		this.url = url;
		return this;
	}

}